import axios from "axios";
import { del, get, post, patch,  put } from "./pre_registration_configurations_api_helper";
import * as url from "./pre_registration_configurations_url_helper";





// Get features
export const getPreRegistrationConfigurations = () => get(url.GET_PRE_REGISTRATION_CONFIGURATIONS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewPreRegistrationConfiguration = preRegistrationConfiguration => post(url.ADD_NEW_PRE_REGISTRATION_CONFIGURATION, JSON.stringify(preRegistrationConfiguration));

export const addNewPreRegistrationConfiguration = preRegistrationConfiguration =>
  axios.post(url.ADD_NEW_PRE_REGISTRATION_CONFIGURATION, preRegistrationConfiguration, {
    headers: { "Content-Type": "application/json" }
  });



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updatePreRegistrationConfiguration = preRegistrationConfiguration => patch(`${url.UPDATE_PRE_REGISTRATION_CONFIGURATION}/${preRegistrationConfiguration.id}`,  preRegistrationConfiguration);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deletePreRegistrationConfiguration = preRegistrationConfiguration => del(`${url.DELETE_PRE_REGISTRATION_CONFIGURATION}/${preRegistrationConfiguration.id}`);







export {
  //getLoggedInUser,
  
  
};
